import { NgOptimizedImage, NgTemplateOutlet } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
    inject,
    input,
} from '@angular/core';
import { RouterLinkWithHref } from '@angular/router';
import { CareerPosition } from '@content/career/career-positions/career-positions.types';
import { AssetPipe } from '@libraries/asset/asset.pipe';
import { AppPath } from '@shared/routes/app-routing.const';
import { CareerDetailsScrollDirective } from '../career-details-scroll.directive';
import { CareerDetailsService } from '../career-details.service';

@Component({
    selector: 'jsdaddy-career-details-header',
    standalone: true,
    templateUrl: './career-details-header.component.html',
    styleUrl: './career-details-header.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgTemplateOutlet,
        RouterLinkWithHref,
        AssetPipe,
        CareerDetailsScrollDirective,
        NgOptimizedImage,
    ],
})
export class CareerDetailsHeaderComponent {
    public career = input.required<CareerPosition | undefined>();
    public readonly assetPath = 'content/career-details/header';
    public readonly careerRoutePath = `/${AppPath.CAREER}`;

    private readonly careerDetailsService = inject(CareerDetailsService);

    public section = this.careerDetailsService.getSection('Project Details');
    public onSectionChange(sectionId: string): void {
        this.careerDetailsService.changeSection(sectionId);
    }
}
